import {defineStore} from 'pinia';

export const useLayoutStore = defineStore('layout', {
  state: () => ({
    bodyFix: false,
    onboarding_shown: false,
    msg: null,
    loading: false,
    lang: null,
    page_loading: false,
    resource: {},
    hasList: false,
    selected_id: null,
    selected_obj: null,
    pagination: null,
    form_add_opened: false,
    active_mobile_menu: false,
    theme: useCookie('theme'),
    permissionPrefix: false,
    socket: null,
    confirm: {
      msg: null,
      visible: false,
    },
  }),

  actions: {
    setBodyFix(val) {
      this.bodyFix = val;
    },

    setLoading(data) {
      this.loading = data;
    },

    setLang(data) {
      this.lang = data;
    },

    setTheme(data) {
      this.theme = data;
      useCookie('theme', {default: () => data, maxAge: 60 * 60 * 24 * 365});
    },

    toggleConfirm(data) {
      if (data) {
        this.confirm = {
          visible: !this.confirm.visible,
          msg: data.msg,
          title: data.title,
        };
      } else {
        this.confirm = {visible: false, msg: '', title: ''};
      }
    },

    setPageLoading(data) {
      this.page_loading = data;
    },

    setMsg(val) {
      this.msg = val;
    },

    resetMsg() {
      this.msg = null;
    },

    setResource(data) {
      this.resource = data;
    },

    emptyFilters() {
      this.filters = {};
    },

    setPagination(data) {
      this.pagination = data;
    },

    setOnboardingShown(data) {
      this.onboarding_shown = data;
    },

    toggleFormAdd(val) {
      this.form_add_opened = val !== undefined ? val : !this.form_add_opened;
    },

    toggleMobileMenu(val) {
      this.active_mobile_menu =
        val !== undefined ? val : !this.active_mobile_menu;
    },

    setPermissionPrefix(data) {
      this.permissionPrefix = data;
    },
  },
});
